import { createContext } from 'react'

import {
  PdfOutputDto,
  PdfTypeEnum,
  QueryGetPdfsByClientProposalIdArgs,
} from '../../../lib/graphql'

export type GetPdfQueryResult = {
  data: Pick<PdfOutputDto, 'filename' | 'url' | 'pdfType'>[]
  isLoading: boolean
  isError: boolean
}

export interface IPdfContext {
  pdfTypes: PdfTypeEnum[]
  getPdfs: (
    pdfTypes: PdfTypeEnum[],
    regenerate?: boolean,
  ) => Promise<PdfOutputDto[]>
  useGetPdfsByClientProposalIdQuery: (
    agrs: QueryGetPdfsByClientProposalIdArgs,
  ) => GetPdfQueryResult
  isGeneratingDocuments?: boolean
}

export const PdfContext = createContext<IPdfContext>({
  pdfTypes: [],
  getPdfs: async () => {
    return []
  },
  useGetPdfsByClientProposalIdQuery: () => ({
    data: [],
    isError: false,
    isLoading: false,
  }),
  isGeneratingDocuments: false,
})
